import styled from 'styled-components';
import { primaryColor, wMBold, maxWidth, retina, maxTablet, primaryFont, greyColorSecondary, maxMobile } from '../../../Utils/utilsStyle';
import GlobalButton from '../components/GlobalButton';
import InfoIconTwo from 'Components/common/assets/svgIcons/InfoIconTwo';

const Footer = styled.div<{ isInfoSection?: boolean }>`
  padding: 8px 16px;
  border-top: 1px solid #E5E5E5;
  display: flex;
  justify-content: ${props => props.isInfoSection ? 'space-between' : 'flex-end'};
  background-color: #f9f8f6;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  .advance-search-footer-btn {
    height: 32px;
    padding: 6px 16px;
    font-weight: ${wMBold};
    background-color: ${primaryColor};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 12px;
    }
  }
`;

const InfoMsg = styled.div`
display: flex;
align-items: center;
gap: 6px;
color: ${greyColorSecondary};
font-family: ${primaryFont};
font-size: 12px;
letter-spacing: -0.442px;
@media all and (max-width: ${maxTablet}) {
  font-size: 11px;
  gap: 4px;
}
@media all and (max-width: ${maxMobile}) {
  font-size: 9px;
  gap: 2px;
}
svg {
  height: 14px;
  @media all and (max-width: ${maxTablet}) {
    height: 13px;
  }
}
`;

interface DropdownFooterProps {
  title: string;
  disabled: boolean;
  onApply: () => void;
  infoMsg?: string;
  isInfoSection?: boolean;
}

export const DropdownFooter = ({ disabled, onApply, title, infoMsg, isInfoSection = false }: DropdownFooterProps) => {
  return (
    <Footer isInfoSection={isInfoSection}>
      {isInfoSection && (
        <InfoMsg>
          <InfoIconTwo />
          <span>{infoMsg}</span>
        </InfoMsg>
      )}
      <GlobalButton
        disabled={disabled}
        onButtonClick={onApply}
        title={title}
        buttonClassName='advance-search-footer-btn'
      />
    </Footer>
  )
}
